import { render } from "./SalesPerBrandSkeleton.vue?vue&type=template&id=76b995db&scoped=true"
import script from "./SalesPerBrandSkeleton.vue?vue&type=script&lang=js"
export * from "./SalesPerBrandSkeleton.vue?vue&type=script&lang=js"

import "./SalesPerBrandSkeleton.vue?vue&type=style&index=0&id=76b995db&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76b995db"]])

export default __exports__